module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iuAc6"))).then(() => parcelRequire('hEqeo'));